export enum VaccineApplicationState {
  PENDING = 'PENDING',
  PENDING_APPLICATION = 'PENDING_APPLICATION',
  FINALIZED = 'FINALIZED',
  CANCELED = 'CANCELED'
}
